/* eslint-disable react/jsx-no-target-blank */
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import * as routes from 'router/routes'
import {
  is_superAdmin,
  is_societyAdmin,
  is_technician,
  is_vendor,
  is_subAdmin,
} from 'helpers/userRoles'
import {useSelector} from 'react-redux'
import {has_screenPermission} from 'helpers/userPermissions'
import {PERMISSION_ID} from 'constants'

export function AsideMenuMain() {
  const {user, permissions_enum} = useSelector((state) => state.auth)

  const check_Permission = (id) => has_screenPermission(permissions_enum, id, user)

  return (
    <>
      {!is_technician(user) && !is_vendor(user) && (
        <AsideMenuItem
          to={routes.DASHBOARD}
          icon='/media/icons/duotune/art/art002.svg'
          title='Dashboard'
          fontIcon='bi-app-indicator'
        />
      )}

      {is_societyAdmin(user) && (
        <>
          {check_Permission(PERMISSION_ID.users) && (
            <AsideMenuItemWithSub
              to={routes.USERS}
              title='Users'
              icon='/media/icons/duotune/general/gen025.svg'
              fontIcon='bi-layers'
            >
              <AsideMenuItemWithSub to={routes.OCCUPANT} title='Occupants' hasBullet={true}>
                <AsideMenuItem
                  to={routes.OCCUPANTS_CREATE}
                  title='Create Occupant'
                  hasBullet={true}
                />
                <AsideMenuItem to={routes.OCCUPANTS_LIST} title='Occupants List' hasBullet={true} />
                <AsideMenuItem
                  to={routes.PENDING_OCCUPANTS_LIST}
                  title='Pending Occupants'
                  hasBullet={true}
                />
              </AsideMenuItemWithSub>

              <AsideMenuItemWithSub to={routes.GUARDS} title='Guards' hasBullet={true}>
                <AsideMenuItem to={routes.GUARDS_CREATE} title='Create Guard' hasBullet={true} />
                <AsideMenuItem to={routes.GUARDS_LIST} title='Guards List' hasBullet={true} />
              </AsideMenuItemWithSub>

              <AsideMenuItemWithSub to={routes.ADMINS} title='Admins' hasBullet={true}>
                {/* <AsideMenuItem to={routes.ADMINS_CREATE} title='Create Admin' hasBullet={true} /> */}
                {!is_subAdmin(user) && (
                  <AsideMenuItem to={routes.ADMINS_CREATE} title='Create Admin' hasBullet={true} />
                )}

                <AsideMenuItem to={routes.ADMINS_LIST} title='Admins List' hasBullet={true} />
              </AsideMenuItemWithSub>

              <AsideMenuItemWithSub to={routes.TECHNICIANS} title='Technicians' hasBullet={true}>
                <AsideMenuItem
                  to={routes.TECHNICIANS_CREATE}
                  title='Create Technician'
                  hasBullet={true}
                />
                <AsideMenuItem
                  to={routes.TECHNICIANS_LIST}
                  title='Technicians List'
                  hasBullet={true}
                />
              </AsideMenuItemWithSub>
              {/* <AsideMenuItemWithSub to={routes.VENDORS} title='Vendors' hasBullet={true}>
                <AsideMenuItem to={routes.CREATE_VENDORS} title='Create Vendor' hasBullet={true} />
                <AsideMenuItem to={routes.VENDORS_LIST} title='Vendors List' hasBullet={true} />
              </AsideMenuItemWithSub> */}

              <AsideMenuItemWithSub to={routes.VISITORS} title='Visitors' hasBullet={true}>
                <AsideMenuItem
                  to={routes.VISITORS_QR_CODE}
                  title='QR Applied List'
                  hasBullet={true}
                />
              </AsideMenuItemWithSub>
            </AsideMenuItemWithSub>
          )}

          {check_Permission(PERMISSION_ID.societies) && (
            <AsideMenuItemWithSub
              to={routes.SOCIETY_STRUCTURE}
              title='Society Structure'
              icon='/media/icons/duotune/general/gen025.svg'
              fontIcon='bi-layers'
            >
              <AsideMenuItem
                to={routes.SOCIETY_STRUCTURE_UPLOAD}
                title='Upload Society Structure'
                hasBullet={true}
              />

              <AsideMenuItem
                to={routes.SOCIETY_STRUCTURE_PROPERTIES}
                title='Properties List'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
          )}

          {check_Permission(PERMISSION_ID.announcements) && (
            <AsideMenuItemWithSub
              to={routes.ANNOUNCEMENTS}
              title='Announcements'
              icon='/media/icons/duotune/general/gen025.svg'
              fontIcon='bi-layers'
            >
              <AsideMenuItem
                to={routes.ANNOUNCEMENTS_CREATE}
                title='Create Announcement'
                hasBullet={true}
              />
              <AsideMenuItem
                to={routes.ANNOUNCEMENTS_LIST}
                title='Announcements List'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
          )}

          {check_Permission(PERMISSION_ID.logs) && (
            <AsideMenuItemWithSub
              to={routes.ENTRY_EXIT_LOGS}
              title='Entry / Exit Logs'
              icon='/media/icons/duotune/general/gen025.svg'
              fontIcon='bi-layers'
            >
              <AsideMenuItem
                to={routes.ENTRY_EXIT_LOGS_LIST}
                title='Entry / Exit Logs List'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
          )}

          {check_Permission(PERMISSION_ID.invoices) && (
            <AsideMenuItemWithSub
              to={routes.INVOICES}
              title='Invoices'
              icon='/media/icons/duotune/general/gen025.svg'
              fontIcon='bi-layers'
            >
              <AsideMenuItem to={routes.INVOICES_CREATE} title='Create Invoice' hasBullet={true} />
              <AsideMenuItem to={routes.INVOICES_LIST} title='Invoices List' hasBullet={true} />
            </AsideMenuItemWithSub>
          )}

          {check_Permission(PERMISSION_ID.ads) && (
            <AsideMenuItemWithSub
              to={routes.ADS}
              title='Marketplace'
              icon='/media/icons/duotune/general/gen025.svg'
              fontIcon='bi-layers'
            >
              {/* <AsideMenuItem to={routes.ADS_CREATE} title='Create Ad' hasBullet={true} /> */}
              <AsideMenuItem to={routes.ADS_LIST} title='Ads List' hasBullet={true} />
            </AsideMenuItemWithSub>
          )}

          {check_Permission(PERMISSION_ID.complaints) && (
            <AsideMenuItemWithSub
              to={routes.COMPLAINTS}
              title='Complaints'
              icon='/media/icons/duotune/general/gen025.svg'
              fontIcon='bi-layers'
            >
              {/* <AsideMenuItem to={routes.COMPLAINTS_CREATE} title='Create Complaint' hasBullet={true} /> */}
              <AsideMenuItem to={routes.COMPLAINTS_LIST} title='Complaints List' hasBullet={true} />
            </AsideMenuItemWithSub>
          )}

          {check_Permission(PERMISSION_ID.emails) && (
            <AsideMenuItemWithSub
              to={routes.EMAILS}
              title='Emails'
              icon='/media/icons/duotune/general/gen025.svg'
              fontIcon='bi-layers'
            >
              <AsideMenuItem to={routes.EMAILS_LIST} title='Emails List' hasBullet={true} />
            </AsideMenuItemWithSub>
          )}

          {check_Permission(PERMISSION_ID.pushNotifications) && (
            <AsideMenuItemWithSub
              to={routes.PUSH_NOTIFICATIONS}
              title='Push Notifications'
              icon='/media/icons/duotune/general/gen025.svg'
              fontIcon='bi-layers'
            >
              <AsideMenuItem
                to={routes.PUSH_NOTIFICATIONS_LIST}
                title='Push Notifications List'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
          )}

          {check_Permission(PERMISSION_ID.survey) && (
            <AsideMenuItemWithSub
              to={routes.SURVEYS}
              title='Surveys'
              icon='/media/icons/duotune/general/gen025.svg'
              fontIcon='bi-layers'
            >
              <AsideMenuItem to={routes.SURVEYS_CREATE} title='Create Survey' hasBullet={true} />
              <AsideMenuItem to={routes.SURVEYS_LIST} title='Surveys List' hasBullet={true} />
            </AsideMenuItemWithSub>
          )}

          {/* {check_Permission(PERMISSION_ID.brands) && (
            <AsideMenuItemWithSub
              to={routes.BRANDS}
              title='Brands'
              icon='/media/icons/duotune/general/gen025.svg'
              fontIcon='bi-layers'
            >
              <AsideMenuItem to={routes.BRANDS_CREATE} title='Create Brand' hasBullet={true} />
              <AsideMenuItem to={routes.BRANDS_LIST} title='Brands List' hasBullet={true} />
            </AsideMenuItemWithSub>
          )} */}

          {/* {check_Permission(PERMISSION_ID.brandAds) && (
            <AsideMenuItemWithSub
              to={routes.BRANDADS}
              title='Brand Ads'
              icon='/media/icons/duotune/general/gen025.svg'
              fontIcon='bi-layers'
            >
              <AsideMenuItem
                to={routes.BRANDADS_CREATE}
                title='Create Brand Ads'
                hasBullet={true}
              />
              <AsideMenuItem to={routes.BRANDADS_LIST} title='Brand Ads List' hasBullet={true} />
            </AsideMenuItemWithSub>
          )} */}

          {check_Permission(PERMISSION_ID.ticket) && (
            <AsideMenuItemWithSub
              to={routes.TICKETS}
              title='Tickets'
              icon='/media/icons/duotune/general/gen025.svg'
              fontIcon='bi-layers'
            >
              <AsideMenuItem to={routes.TICKETS_CREATE} title='Create Ticket' hasBullet={true} />
              <AsideMenuItem to={routes.TICKETS_LIST} title='Tickets List' hasBullet={true} />
            </AsideMenuItemWithSub>
          )}
          {check_Permission(PERMISSION_ID.panicQueries) && (
            <AsideMenuItemWithSub
              to={routes.PANIC_QUERIES}
              title='Panic Queries'
              icon='/media/icons/duotune/general/gen025.svg'
              fontIcon='bi-layers'
            >
              <AsideMenuItem to={routes.PANIC_QUERIES_LIST} title='Panic Queries List' hasBullet={true} />
            </AsideMenuItemWithSub>
          )}
        </>
      )}

      {is_technician(user) && (
        <AsideMenuItemWithSub
          to={routes.COMPLAINTS}
          title='My Complaints'
          icon='/media/icons/duotune/general/gen025.svg'
          fontIcon='bi-layers'
        >
          {/* <AsideMenuItem to={routes.COMPLAINTS_CREATE} title='Create Complaint' hasBullet={true} /> */}
          <AsideMenuItem to={routes.COMPLAINTS_LIST} title='Complaints List' hasBullet={true} />
        </AsideMenuItemWithSub>
      )}
      {is_vendor(user) && (
        <AsideMenuItem
          icon='/media/icons/duotune/general/gen025.svg'
          fontIcon='bi-layers'
          to={routes.BOOKING_LIST}
          title='Booking List'
          hasBullet={false}
        />
      )}

      {is_superAdmin(user) && (
        <AsideMenuItemWithSub
          to={routes.SERVICE}
          title='Services'
          icon='/media/icons/duotune/general/gen025.svg'
          fontIcon='bi-layers'
        >
          <AsideMenuItem to={routes.CREATE_SERVICE} title='Create Services ' hasBullet={true} />
          <AsideMenuItem to={routes.SERVICELIST} title='Services List' hasBullet={true} />
        </AsideMenuItemWithSub>
      )}

      {is_superAdmin(user) && (
        <AsideMenuItemWithSub
          to={routes.SOCIETIES}
          title='Societies'
          icon='/media/icons/duotune/general/gen025.svg'
          fontIcon='bi-layers'
        >
          <AsideMenuItem to={routes.SOCIETIES_CREATE} title='Create Society' hasBullet={true} />
          <AsideMenuItem to={routes.SOCIETIES_LIST} title='Societies List' hasBullet={true} />
        </AsideMenuItemWithSub>
      )}

      {is_superAdmin(user) && (
        <AsideMenuItemWithSub
          to={routes.SURVEYS}
          title='Surveys'
          icon='/media/icons/duotune/general/gen025.svg'
          fontIcon='bi-layers'
        >
          <AsideMenuItem to={routes.SURVEYS_CREATE} title='Create Survey' hasBullet={true} />
          <AsideMenuItem to={routes.SURVEYS_LIST} title='Surveys List' hasBullet={true} />
        </AsideMenuItemWithSub>
      )}

      {is_superAdmin(user) && (
        <AsideMenuItemWithSub
          to={routes.TICKETS}
          title='Tickets'
          icon='/media/icons/duotune/general/gen025.svg'
          fontIcon='bi-layers'
        >
          <AsideMenuItem to={routes.TICKETS_LIST} title='Tickets List' hasBullet={true} />
        </AsideMenuItemWithSub>
      )}

      {is_superAdmin(user) && (
        <AsideMenuItemWithSub
          to={routes.BRANDS}
          title='Brands'
          icon='/media/icons/duotune/general/gen025.svg'
          fontIcon='bi-layers'
        >
          <AsideMenuItem to={routes.BRANDS_CREATE} title='Create Brand' hasBullet={true} />
          <AsideMenuItem to={routes.BRANDS_LIST} title='Brands List' hasBullet={true} />
        </AsideMenuItemWithSub>
      )}

      {is_superAdmin(user) && (
        <AsideMenuItemWithSub
          to={routes.BRANDADS}
          title='Brand Ads'
          icon='/media/icons/duotune/general/gen025.svg'
          fontIcon='bi-layers'
        >
          <AsideMenuItem to={routes.BRANDADS_CREATE} title='Create Brand Ads' hasBullet={true} />
          <AsideMenuItem to={routes.BRANDADS_LIST} title='Brand Ads List' hasBullet={true} />
        </AsideMenuItemWithSub>
      )}

      {is_superAdmin(user) && (
        <AsideMenuItemWithSub
          to={routes.SERVICE_CATEGORY}
          title='Service Category'
          icon='/media/icons/duotune/general/gen025.svg'
          fontIcon='bi-layers'
        >
          <AsideMenuItem
            to={routes.SERVICE_CATEGORY_CREATE}
            title='Create Service Category'
            hasBullet={true}
          />
          <AsideMenuItem
            to={routes.SERVICE_CATEGORY_LIST}
            title='Service Category List'
            hasBullet={true}
          />
        </AsideMenuItemWithSub>
      )}
      {is_superAdmin(user) && (
        <AsideMenuItemWithSub
          to={routes.VENDORS}
          title='Vendors'
          icon='/media/icons/duotune/general/gen025.svg'
          fontIcon='bi-layers'
        >
          <AsideMenuItem to={routes.VENDORS_LIST} title='Vendors List' hasBullet={true} />
        </AsideMenuItemWithSub>
      )}

      {is_superAdmin(user) && (
        <AsideMenuItemWithSub
          to={routes.ANNOUNCEMENTS}
          title='Announcements'
          icon='/media/icons/duotune/general/gen025.svg'
          fontIcon='bi-layers'
        >
          <AsideMenuItem
            to={routes.ANNOUNCEMENTS_CREATE}
            title='Create Announcement'
            hasBullet={true}
          />
          <AsideMenuItem
            to={routes.ANNOUNCEMENTS_LIST}
            title='Announcements List'
            hasBullet={true}
          />
        </AsideMenuItemWithSub>
      )}
    </>
  )
}
